export type FetchPolicyErrorKind = 'network' | 'timeout' | 'aborted'

export class FetchPolicyError extends Error {
  constructor(
    public readonly kind: FetchPolicyErrorKind,
    message: string,
    public readonly retryable: boolean,
  ) {
    super(message)
    this.name = 'FetchPolicyError'
  }
}

export const toAbortError = (source: 'timeout' | 'signal') =>
  new FetchPolicyError(
    source === 'timeout' ? 'timeout' : 'aborted',
    source === 'timeout' ? 'Request timeout exceeded' : 'Request aborted',
    true,
  )

export const isAbortError = (error: unknown): boolean =>
  error instanceof DOMException
    ? error.name === 'AbortError'
    : error instanceof Error
      ? error.name === 'AbortError'
      : false

export const normalizeFetchError = ({
  error,
  signal,
  requestLabel,
}: {
  error: unknown
  signal: AbortSignal
  requestLabel: string
}) =>
  isAbortError(error)
    ? (signal.reason as FetchPolicyError | undefined) ?? toAbortError('signal')
    : new FetchPolicyError(
        'network',
        error instanceof Error ? error.message : `Network request failed (${requestLabel})`,
        true,
      )
